import * as styles from "./SliderThumbTooltip.css";

import type { JSX } from "react";

import { Slider as BaseSlider } from "@base-ui/react/slider";

import type { SliderTooltipVisibility } from "./Slider.types";

type SliderThumbTooltipProps = {
  index: number;
  visibility: Exclude<SliderTooltipVisibility, "never">;
};

export function SliderThumbTooltip({
  index,
  visibility,
}: SliderThumbTooltipProps): JSX.Element {
  return (
    <BaseSlider.Value
      data-slot="slider-thumb-tooltip"
      render={<span />}
      aria-hidden
      className={styles.bubble({ visibility })}
    >
      {(formattedValues) => (
        <>
          {formattedValues[index]}
          <span className={styles.arrowSlot}>
            <span className={styles.arrow} />
          </span>
        </>
      )}
    </BaseSlider.Value>
  );
}
